export enum FiatRampRoutePaths {
  Buy = '/ramp/trade/buy',
  Sell = '/ramp/trade/sell',
  BuyQuoteList = '/ramp/trade/buy/quotes',
  SellQuoteList = '/ramp/trade/sell/quotes',
}
